import { GOOGLE_API_KEY } from '../helpers/constants';
import type { LoaderOptions } from '../google/loader/googleMapsLoader';
import { GoogleMapsLoader } from '../google/loader/googleMapsLoader';

import type { AutocompleteResult } from './types';

export class AutoCompleteService {
  private loader: GoogleMapsLoader;
  private sessionToken: google.maps.places.AutocompleteSessionToken | null =
    null;

  constructor(language: LoaderOptions['language'] = 'en') {
    this.loader = new GoogleMapsLoader(GOOGLE_API_KEY, {
      language,
    });
  }

  public async getAutocompleteSuggestions(
    input: string
  ): Promise<AutocompleteResult[]> {
    const placesLib = await this.loader.loadLibrary('places');

    try {
      if (!this.sessionToken) {
        this.sessionToken = new placesLib.AutocompleteSessionToken();
      }

      const request = {
        input,
        sessionToken: this.sessionToken,
      };

      const { suggestions } =
        await placesLib.AutocompleteSuggestion.fetchAutocompleteSuggestions(
          request
        );

      return suggestions
        .map((suggestion) => {
          if (!suggestion.placePrediction) {
            return {
              id: '',
              description: '',
            };
          }

          return {
            id: suggestion.placePrediction.placeId,
            description: suggestion.placePrediction.text.toString(),
          };
        })
        .filter((result) => result.id !== '');
    } catch (error) {
      throw new Error(`Failed to get autocomplete suggestions: ${error}`);
    } finally {
      this.sessionToken = null;
    }
  }
}
